"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMicrobialAnalyteValue = void 0;
var lowerCase_1 = __importDefault(require("lodash/lowerCase"));
var startCase_1 = __importDefault(require("lodash/startCase"));
var R = __importStar(require("ramda"));
var index_1 = require("../index");
var getMicrobialAnalyteValue = function (row) {
    return startCase_1.default(lowerCase_1.default(R.prop(row.parameter.referenceComponent.rawName, row.results)));
};
exports.getMicrobialAnalyteValue = getMicrobialAnalyteValue;
var getMicrobialLevel = function (levelName) { return function (row) {
    return R.prop(levelName, row.parameter) + " " + (row.isSolid
        ? row.parameter.weightUnitOfMeasure
        : row.parameter.volumeUnitOfMeasure);
}; };
var columnsFactory = function (_a) {
    var _b = _a.addPassFail, addPassFail = _b === void 0 ? false : _b;
    return __spreadArrays([
        index_1.AnalyteColumn,
        { Header: "LOD", width: 50, accessor: getMicrobialLevel("levelOfDetection") },
        {
            Header: "LOQ",
            width: 50,
            accessor: getMicrobialLevel("levelOfQuantitation"),
        }
    ], (addPassFail
        ? [
            {
                Header: "Pass/Fail",
                accessor: exports.getMicrobialAnalyteValue,
                width: 50,
            },
        ]
        : []));
};
exports.default = columnsFactory;
//# sourceMappingURL=columns.js.map